export default {
  APP_VERSION: "1.0",
  APP_NAME: "nimblehrms",
  S3_BUCKET_URL: process.env.VUE_APP_S3_BUCKET_URL,
  API_URL: process.env.VUE_APP_DEV_API_URL,
  APP_URL: process.env.VUE_APP_URL,
  JAVA_BASE_URL: process.env.VUE_APP_JAVA_BASE_URL,
  AUTHFAST_BASE_URL: process.env.VUE_APP_AUTH_FAST_BASE_URL,
  AZURE_SCOPES: ["user.read", "contacts.read"],
  AZURE_OAUTH_REDIRECT_URI: `${process.env.VUE_APP_URL}/contacts`,
  AZURE_APP_SECRET: "Cki8Q~K26FcGeWLR_p.Mtx3veCeEBzMOCMUluc.c",
  AZURE_APP_ID: "9d6503bf-23bd-4859-8b6c-152412180685",
  AZURE_AUTHORITY: "https://login.microsoftonline.com/common/",

  PAYMENT_GATEWAY_URL: `${process.env.VUE_APP_PAYMENT_MICRO_SERVICE}/api`,
  PAYMENT_GATEWAY_SOURCE_KEY: process.env.VUE_APP_PAYMENT_SOURCE_KEY,
  // PAYMENT_GATEWAY_URL: `http://localhost:8000/api`,
  // PAYMENT_GATEWAY_SOURCE_KEY:'ESIGNS_LOCAL',
  PAYMENT_REDIRECTION_URL: process.env.VUE_APP_URL,
  SUBSCRIPTION_PGID: process.env.VUE_APP_SUBSCRIPTION_PGID,
  ESIGNS_PRODUCT_ID: process.env.VUE_APP_ESIGNS_PRODUCT_ID,
  WORKING_PAY_SYSTEMS: ["SWIREPAY", "STRIPE"],

  /* WBA Details */
  WBA_API_URL: process.env.VUE_APP_WBA_API_URL,
  WBA_API_KEY: process.env.VUE_APP_WBA_API_KEY,
  WBA_ENV_CODE: process.env.VUE_APP_WBA_ENV_CODE,

  /*APP mode*/
  APP_MODE: process.env.VUE_APP_MODE,
  KF_EMAIL: process.env.VUE_APP_KF_EMAIL,
  EMAIL_REDIRECT_URI: process.env.VUE_APP_REDIRECT_URI,

  /*AI Match */
  AI_MATCH_URL: process.env.VUE_APP_AI_MATCH,
  TENANT_NAME: process.env.VUE_APP_TENANT_NAME || "Tenant",

  CHAT_SOCKET_URL: process.env.VUE_APP_CHAT_SOCKET_URL,
  CHAT_API_SOCKET_URL: process.env.VUE_APP_CHAT_API_SOCKET_URL,
  subscriptions: {
    PRODUCT_ID: "67c1636c38313f39cccdc2c8",
    isenable: true,
    free_trail: "67e2469a14f645be3c90f4d6",
    registertaion: {
      template_id: "67bf0056424d6f21e88398ae",
      entity_id: "67bf00dd424d6f21e883a878",
    },
    plans: {
      template_id: "67e7c247a055098f3335ab2b",
      entity_id: "67ea68f91de1769dcfbb38cf",
    },
    invoice: {
      entity_id: "67c009f2f2c0e10123847a59",
    },
    headers: {
      anonymoususerid: "67e40bbe1f8d25b1cec3dd2e",
      formbuilderid: "67e40ba31f8d25b1cec3dc8c",
      passcode: "xi7i8o",
    },
    allPlans: {
      template_id: "67bff6121aee1df65a845c81",
      entity_id: "67bff62c1aee1df65a845d68",
    },
    products: {
      template_id: "67e7c1f0a055098f3335ab2a",
      entity_id: "67bfebb01aee1df65a837058",
    },
  },

  /* White label application Settings Start */
  logo: process.env.VUE_APP_LOGO || null,
  generate_landing_page_background_from_colors:
    process.env.VUE_APP_BACKGROUND_FROM_COLORS &&
    process.env.VUE_APP_BACKGROUND_FROM_COLORS == "TRUE"
      ? true
      : false,
  landing_page_image: process.env.VUE_APP_LANDING_PAGE,
  extra_supporting_color:
    process.env.VUE_APP_SUPPORTING_COLORS &&
    process.env.VUE_APP_SUPPORTING_COLORS.length
      ? process.env.VUE_APP_SUPPORTING_COLORS.split(",")
      : [],
  applyCustomContent:
    process.env.VUE_APP_CUSTOM_CONTENT &&
    process.env.VUE_APP_CUSTOM_CONTENT.toString() == "TRUE"
      ? true
      : false,
  customHeaderStyles: process.env.VUE_APP_CUSTOM_HEADER_STYLES,
  customSloganStyles: process.env.VUE_APP_CUSTOM_SLOGAN_STYLES,
  customContentStyles: process.env.VUE_APP_CUSTOM_CONTENT_STYLES,
  customLogoStyles: process.env.VUE_APP_CUSTOM_LOGO_STYLES,
  isEnabledSSO:
    process.env.VUE_APP_IS_SSO_ENABLED &&
    process.env.VUE_APP_IS_SSO_ENABLED === "TRUE"
      ? true
      : false,
  isSysUserRegistrationEnabled:
    process.env.VUE_APP_IS_SYS_REG_ENABLED &&
    process.env.VUE_APP_IS_SYS_REG_ENABLED === "TRUE"
      ? true
      : false,
  isTenantUserRegistrationEnabled:
    process.env.VUE_APP_IS_TENANT_REG_ENABLED &&
    process.env.VUE_APP_IS_TENANT_REG_ENABLED === "TRUE"
      ? true
      : false,
  isShowOffline:
    process.env.VUE_APP_IS_SHOW_OFFLINE_ENABLED &&
    process.env.VUE_APP_IS_SHOW_OFFLINE_ENABLED === "TRUE"
      ? true
      : false,
  isShowInternalChat:
    process.env.VUE_APP_IS_SHOW_CHAT_ENABLED &&
    process.env.VUE_APP_IS_SHOW_CHAT_ENABLED === "TRUE"
      ? true
      : false,

  APPLICATION_TYPE: process.env.VUE_APP_APPLICATION_TYPE,
  APPLICATION_NAME: process.env.VUE_APP_APPLICATION_NAME,
  APPLICATION_DESCRIPTION: process.env.VUE_APP_APPLICATION_DESCRIPTION,
  LOGO: process.env.VUE_APP_LOGO,
  CONTENT1: process.env.VUE_APP_CONTENT1,
  CONTENT2: process.env.VUE_APP_CONTENT2,
  FOOTER: process.env.VUE_APP_FOOTER,
  PRIMARY_COLOR: process.env.VUE_APP_PRIMARY_COLOR,
  SECONDARY_COLOR: process.env.VUE_APP_SECONDARY_COLOR,
  HEADING: process.env.VUE_APP_HEADING,
  SLOGAN: process.env.VUE_APP_SLOGAN,

  /* White label application Settings End */

  /* KV kodefast */
  kvKodefastUrl: process.env.VUE_APP_KV_API_BASE_URL,
  authKey: process.env.VUE_APP_KV_API_AUTH_KEY,
  s3BaseUrl: process.env.VUE_APP_ASSETS_S3_BASE_URL,

  /* AI-Dashboards */
  AI_DASHBOARD: process.env.VUE_APP_AI_DASHBOARD,
  // AI Base URL
  AI_BASE_URL: process.env.VUE_APP_AI_BASE_URL,
  AI_BASE_DEV_URL: process.env.VUE_APP_AI_BASE_DEV_URL,

  URL_ENC_KEY:"kodefastmail"
};
